import { Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetAnimalTypeListQuery } from "../../redux/api/handBooksApi/animalTypesApi";
import { EntTypeAnimal } from "../../models/handBooks/typeAnimal";
import { EntTypeAnimalFilter } from "../../models/filters/TypeAnimalFilter";
import { getCookie } from "typescript-cookie";

interface IProps {
  value?: number[] | null;
  onChange?: (value: number[]) => void; 
}

// const SelectMultiAnimalType = ({ value, onChange }: IProps) => {
//   const { t } = useTranslation();
//   const [options, setOptions] = useState<ISelectOption[]>([]);
//   const { data, isLoading, error } = useGetAnimalTypeListQuery();

//   useEffect(() => {
//     if (data?.res) {
//       const newOptions = data.res.map((role: EntTypeAnimal) => ({
//         label: role.nameRu,
//         value: role.id,
//       }));
//       setOptions(newOptions);
//     } else {
//       setOptions([]);
//     }
//   }, [data]);

//   const filteredOptions = useMemo(() => options, [options]);

//   return (
//     <>
//       {error && <div>{t("errorFetchingRoles")}</div>} 
//       <Select
//         mode="multiple"
//         placeholder={t("msg.selectPlaceholder")}
//         loading={isLoading}
//         value={value}
//         onChange={onChange}
//         options={filteredOptions}
//         filterOption={defaultFilterOption}
//         showSearch
//         allowClear
//       />
//     </>
//   );
// };

// export default SelectMultiAnimalType;

const SelectMultiAtimalTypeSingle = ({ value, onChange }: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);
  const { data, isLoading, error } = useGetAnimalTypeListQuery(new EntTypeAnimalFilter);

  useEffect(() => {
    if (data?.res) {
      const newOptions = data.res.content.map((a: EntTypeAnimal) => ({
        label: getCookie('i18next') === 'ky' ? a.nameKy : a.nameRu,
        value: a.id,
      }));
      setOptions(newOptions);
    } else {
      setOptions([]);
    }
  }, [data]);

  const handleChange = (selectedValues: number[]) => {
    if (selectedValues.length <= 1) {
      onChange?.(selectedValues);
    }
  };

  const filteredOptions = useMemo(() => options, [options]);

  return (
    <>
      {error && <div>{t("errorFetchingRoles")}</div>}
      <Select
        mode="multiple"
        placeholder={t("msg.selectPlaceholder")}
        loading={isLoading}
        value={value}
        onChange={handleChange}
        options={filteredOptions}
        filterOption={defaultFilterOption}
        showSearch
        allowClear
      />
    </>
  );
};

export default SelectMultiAtimalTypeSingle;

